module.exports = __webpack_public_path__ + "static/media/2480265.41325698.png";